/**
 * @generated SignedSource<<4ea3db0483bdd031519daa1829fd72ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnpinnedEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"TimelineRowEventActor">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly " $fragmentType": "UnpinnedEvent";
};
export type UnpinnedEvent$key = {
  readonly " $data"?: UnpinnedEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnpinnedEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnpinnedEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TimelineRowEventActor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnpinnedEvent",
  "abstractKey": null
};

(node as any).hash = "eef8cbf61d406f2f45179aa6e2012d23";

export default node;
